import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { DataProvider, useDataProvider, useRecordContext } from 'react-admin';
import { parseCampaignResponses } from './campaignDailyReport';

interface CampaignDataProvider extends DataProvider {
    getAny: (resource: string, params?: string) => Promise<{ data: unknown }>;
}

export const useCampaignResponses = () => {
    const record = useRecordContext<{ guid: string }>();
    const dataProvider = useDataProvider<CampaignDataProvider>();
    const query = useQuery({
        queryKey: ['campaign-responses', record?.guid],
        queryFn: async () => {
            const { data } = await dataProvider.getAny(`campaign/${record.guid}/responses`);
            return parseCampaignResponses(data);
        },
        enabled: Boolean(record?.guid),
        refetchOnMount: 'always',
    });
    React.useEffect(() => {
        if (query.error) console.error(query.error);
    }, [query.error]);
    return query;
};
